
export default function Features() {
  return (
    <section id="features" className="relative py-60 px-20 overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/78cd3107ebba7363e7a548681a1fa490.jpg)'
        }}
      ></div>
      
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/50 to-black/60"></div>
      
      <div className="relative max-w-[1440px] mx-auto text-center">
        <h2 className="text-8xl font-black text-white mb-10 tracking-tight" style={{ textShadow: '0px 2px 8px rgba(0,0,0,0.3)' }}>
          ENTERPRISE-GRADE<br />SECURITY
        </h2>
        
        <div className="space-y-2 mb-14">
          <p className="text-2xl text-white/90 font-light">
            Advanced encryption protocols
          </p>
          <p className="text-2xl text-white/90 font-light">
            Protecting millions of users worldwide
          </p>
        </div>
        
        <div className="flex justify-center">
          <div 
            className="w-16 h-16 rounded-full bg-orange-500 flex items-center justify-center"
            style={{ boxShadow: '0px 0px 24px rgba(255,107,53,0.4)' }}
          >
            <i className="ri-shield-check-line text-3xl text-white"></i>
          </div>
        </div>
      </div>
    </section>
  );
}
